import { Route, Routes } from "react-router-dom";

import { CheckoutPaymentLInk } from "../../pages";

export const CheckoutPaymentLinkLayout = () => {
  return (
    <Routes>
      <Route path="/" element={<CheckoutPaymentLInk />} />
    </Routes>
  );
};
